























































// @ts-nocheck
import Vue from 'vue';
import { PayDialogStore, DetailStore } from '@/store/index';
import { FitHalfScreenDialog, FitButton, FitKeyboard } from '@/fit-ui';
import { parseAmount } from '@/business/helper';
import charity from '@/business/charity';
import { biHottag } from '@tencent/ppd-base-libs';
import { DonateBtnType } from '@/types';

export default Vue.extend({
  name: 'PayDialog',
  data() {
    return {
      DetailStore,
      PayDialogStore,
      moneyFocus: false,
      keyboardFocus: true,
      showKeyboard: 'open',
      showKeyboardBlank: false,
      showDialog: false,
      isTextDonateBtnType: false,
      selectedOptionDesc: DetailStore.amountOptions[0].desc,
    };
  },
  activated() {
    PayDialogStore.selectedAmount = DetailStore.amountOptions[0].amount;
    this.selectedOptionDesc = DetailStore.amountOptions[0].desc;
    this.isTextDonateBtnType = DetailStore.donateBtnType === DonateBtnType.Text;
    this.hightlightBtn();
  },
  deactivated() {
    this.handleDialogClose();
  },
  mounted() {
    document.addEventListener('touchend', this.eHandler);
  },
  watch: {
    'PayDialogStore.show': function(newVal) {
      if(newVal) {
        this.disableBodyScroll();
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.enableBodyScroll();
      PayDialogStore.show = false;
    },
    disableBodyScroll() {
      document.body.style.overflow = 'hidden';
    },
    enableBodyScroll() {
      document.body.style.overflow = 'auto';
    },
    handleSwicthPresetLevel(value: number) {
      PayDialogStore.isUsePreset = true;
      PayDialogStore.selectedLevel = value + 1;
      PayDialogStore.selectedAmount = DetailStore.amountOptions[value].amount;
      this.selectedOptionDesc = DetailStore.amountOptions[value].desc;
      PayDialogStore.inputAmount = '';
      this.hightlightBtn();
    },
    handleSwitchNeedReceipt() {
      PayDialogStore.need_receipt = PayDialogStore.need_receipt === '0' ? '1' : '0';
      biHottag('wallet.charity.detail.reciept_click');
    },
    handleClickConfirm() {
      if (!PayDialogStore.btnActive) {
        return;
      }
      // 无需收据时，直接跳转捐款
      if (PayDialogStore.need_receipt === '0') {
        charity.orderReq(true);
        return;
      }
      this.enableBodyScroll();
      this.$router.push({ path: 'person' });
      biHottag('wallet.charity.detail.order_click', {
        fcharity_project: sessionStorage.getItem('pid'),
        fcharity_organization: sessionStorage.getItem('oid'),
      });
    },
    eBlur() {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollTop;
      }, 50);
    },
    eClickMoney() {
      this.moneyFocus = true;
      this.showKeyboardBlank = true;
      PayDialogStore.isUsePreset = false;
      this.hightlightBtn();
    },
    eTap(obj) {
      if ('DEL' === obj.detail.value) {
        PayDialogStore.inputAmount = PayDialogStore.inputAmount.substr(0, PayDialogStore.inputAmount.length - 1);
      } else {
        PayDialogStore.inputAmount += obj.detail.value;
        PayDialogStore.inputAmount = parseAmount(PayDialogStore.inputAmount, '');
        charity.checkAmount();
      }
      this.hightlightBtn();
    },
    hightlightBtn() {
      if (!PayDialogStore.isUsePreset) {
        // 最低金额限制检查
        const inMoney = parseFloat(PayDialogStore.inputAmount || '0');
        if (0 === inMoney || inMoney < (this.DetailStore.lowAmount || 0.1)) {
          PayDialogStore.btnActive = false;
          return;
        }
      }
      PayDialogStore.btnActive = true;
    },
    eHandler(e) {
      if (!this.moneyFocus) {
        return;
      }
      let curT = e.target;
      let isHide = true;
      while (curT) {
        if (curT.attributes.useSelfKeyboard) {
          isHide = false;
          break;
        }
        curT = curT.offsetParent;
      }

      if (isHide) {
        this.moneyFocus = false;
        this.eBlur();
        setTimeout(() => {
          this.showKeyboardBlank = false;
        }, 100);
      }
    },
  },
  components: {
    FitHalfScreenDialog,
    FitButton,
    FitKeyboard,
  },
});
